let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8bkDf")).then(() => parcelRequire('3NfW0'));